import { lazy } from "react";
import { createBrowserRouter } from "react-router";

import { composeHOCs } from "@/route-guards/compose-hocs.ts";
import { withAuthGuard } from "@/route-guards/with-auth-guard.tsx";
import { withGuest } from "@/route-guards/with-guest.tsx";
import { withGuestGuard } from "@/route-guards/with-guest-guard.tsx";
import { withSuspense } from "@/route-guards/with-suspense.tsx";

const Layout = lazy(() => import("@/layout.tsx"));
const RouteErrorBoundary = lazy(() => import("@/pages/route-error-boundary.tsx"));
const Home = lazy(() => import("@/pages/home.tsx"));
const Login = lazy(() => import("@/pages/login.tsx"));
const Register = lazy(() => import("@/pages/register.tsx"));
const MyJobs = lazy(() => import("@/pages/my-jobs.tsx"));
const RequestPublishing = lazy(() => import("@/pages/request-publishing.tsx"));
const Account = lazy(() => import("@/pages/account.tsx"));
const Admin = lazy(() => import("@/pages/admin.tsx"));
const NotFound = lazy(() => import("@/pages/not-found.tsx"));
const DataSubmission = lazy(() => import("@/pages/data-submission.tsx"));
const News = lazy(() => import("@/pages/news-page.tsx"));
const Reports = lazy(() => import("@/pages/reports.tsx"));
const SiteSettings = lazy(() => import("@/pages/site-settings-page.tsx"));
const Calendarium = lazy(() => import("@/pages/calendarium.tsx"));

export const router = createBrowserRouter([
    {
        path: "/",
        Component: composeHOCs(Layout, withSuspense),
        ErrorBoundary: composeHOCs(RouteErrorBoundary, withSuspense),
        children: [
            { index: true, Component: composeHOCs(Home, withSuspense) },
            { path: "/login", Component: composeHOCs(Login, withGuestGuard, withSuspense) },
            { path: "/register", Component: composeHOCs(Register, withGuestGuard, withGuest, withSuspense) },
            {
                path: "/myjobs",
                Component: composeHOCs(MyJobs, withAuthGuard(["model", "teacher", "admin"]), withSuspense),
            },
            {
                path: "/publish",
                Component: composeHOCs(RequestPublishing, withAuthGuard(["teacher", "admin"]), withSuspense),
            },
            {
                path: "/account",
                Component: composeHOCs(
                    Account,
                    withAuthGuard(["model", "teacher", "admin", "unassigned"]),
                    withSuspense,
                ),
            },
            {
                path: "/admin",
                Component: composeHOCs(Admin, withAuthGuard(["admin"]), withSuspense),
            },
            {
                path: "/site-settings",
                Component: composeHOCs(SiteSettings, withAuthGuard(["admin"]), withSuspense),
            },
            {
                path: "/news",
                Component: composeHOCs(News, withAuthGuard(["admin"]), withSuspense),
            },
            {
                path: "/data-submission",
                Component: composeHOCs(DataSubmission, withAuthGuard(["admin", "model"]), withSuspense),
            },
            {
                path: "/reports",
                Component: composeHOCs(Reports, withAuthGuard(["admin"]), withSuspense),
            },
            {
                path: "/calendarium",
                Component: composeHOCs(Calendarium, withAuthGuard(["admin", "model"]), withSuspense),
            },
        ],
    },
    { path: "*", Component: composeHOCs(NotFound, withSuspense) },
]);
